import React from 'react'
import PropTypes from 'prop-types'
import { Input, Dropdown, Checkbox, Popup } from 'semantic-ui-react'
import { getLocalDateTimeInputValue } from 'utils/dateTimeLocal'

export const DateTimePicker = ({
  type,
  value,
  onChange,
  trafficEnabled,
  trafficAvailable,
  onTrafficChange,
}) => {
  return (
    <div
      className="pa2 flex flex-wrap"
      style={{ gap: '0.5rem', alignItems: 'center' }}
    >
      <Dropdown
        clearable
        options={[
          {
            key: 0,
            text: 'Nonspecific time',
            value: -1,
          },
          {
            key: 1,
            text: 'Leave now',
            value: 0,
          },
          {
            key: 2,
            text: 'Depart at',
            value: 1,
          },
          {
            key: 3,
            text: 'Arrive at',
            value: 2,
          },
        ]}
        selection
        value={type}
        style={{ marginLeft: '3px' }}
        onChange={(e, data) => {
          const nextType = data.value
          onChange('type', nextType)
          // Default the picker to current local date/time when choosing depart/arrive
          if (
            (nextType === 1 || nextType === 2) &&
            (!value || String(value).endsWith('Z'))
          ) {
            onChange('value', getLocalDateTimeInputValue())
          }
        }}
      />
      <Input placeholder="Search..." style={{ marginLeft: '3px' }}>
        <input
          type="datetime-local"
          value={value || ''}
          onChange={(e) => onChange('value', e.target.value)}
          disabled={type < 1}
        />
      </Input>
      <Popup
        content={
          trafficAvailable
            ? 'Overlay Mapbox driving-traffic times on Drivepoints routes (autodp/truckdp only)'
            : 'Traffic overlay requires autodp or truckdp and a Mapbox access token'
        }
        size="tiny"
        trigger={
          <Checkbox
            label="Traffic (Mapbox)"
            checked={!!trafficEnabled}
            disabled={!trafficAvailable}
            onChange={(e, data) =>
              onTrafficChange && onTrafficChange(data.checked)
            }
            style={{ marginLeft: '8px' }}
          />
        }
      />
    </div>
  )
}

DateTimePicker.propTypes = {
  type: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func,
  trafficEnabled: PropTypes.bool,
  trafficAvailable: PropTypes.bool,
  onTrafficChange: PropTypes.func,
}
